import { HsRegularGeometryData } from '../geometry-utils/regular-geometry-data.class';

export function hsGenerateCubeGeometryData(): HsRegularGeometryData {
  const vertices: number[] = [];
  const normals: number[] = [];
  const a: [number, number, number] = [1, 1, 1];
  const b: [number, number, number] = [-1, 1, 1];
  const c: [number, number, number] = [-1, -1, 1];
  const d: [number, number, number] = [1, -1, 1];
  const e: [number, number, number] = [1, 1, -1];
  const f: [number, number, number] = [-1, 1, -1];
  const g: [number, number, number] = [-1, -1, -1];
  const h: [number, number, number] = [1, -1, -1];
  // upper side
  vertices.push(...a, ...b, ...f, ...a, ...f, ...e);
  normals.push(0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0);
  // lower side
  vertices.push(...d, ...g, ...c, ...d, ...h, ...g);
  normals.push(0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0);
  // front side
  vertices.push(...a, ...c, ...b, ...a, ...d, ...c);
  normals.push(0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1);
  // back side
  vertices.push(...e, ...f, ...g, ...e, ...g, ...h);
  normals.push(0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1);
  // right side
  vertices.push(...b, ...c, ...g, ...b, ...g, ...f);
  normals.push(1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0);
  // left side
  vertices.push(...a, ...e, ...h, ...a, ...h, ...d);
  normals.push(-1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0);
  return new HsRegularGeometryData(vertices, normals);
}
